<template>
  <div>
    <div class="text-xs-right">
      <v-btn fab flat small @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>
    </div>

    <v-layout wrap>
      <v-flex xs12 sm4 class="pa-2">
        <h2>{{ $t('Print Cover') }}</h2>
        <template v-if="profile">
          <label class="caption" for>{{ $t('Shop address') }}</label>
          <div class="form-control">
            <textarea
              name
              id
              class="form-control"
              rows="5"
              style="min-height: 90px;resize: vertical; width: 100%"
              v-model="profile.pageaddress"
            ></textarea>
          </div>
          <span class="caption warning-message">{{
            $t('Note* Your address is able to change in setting menu permanently')
          }}</span>
          <br />
          <br />
        </template>
        <label class="caption" for>{{ $t('Customer Address') }}</label>
        <div class="form-control">
          <textarea
            name
            id
            class="form-control"
            rows="5"
            style="min-height: 90px;resize: vertical; width: 100%"
            v-model="order.nameaddress"
          ></textarea>
        </div>
        <br />
        <div class="text-xs-right">
          <v-btn outline color="grey" @click="$emit('close')">{{ $t('cancel') }}</v-btn>
          <v-btn depressed color="primary" @click="printCover">{{ $t('Print') }}</v-btn>
        </div>
        <br />
      </v-flex>
      <v-flex xs12 sm8>
        <div style="background: grey;overflow: auto;border: 1px solid #eee;">
          <div style="width: 230mm;margin: auto">
            <div :id="`printable_${this.order.id}`" class="printable page">
              <v-container fluid class="cover-address" grid-list-md>
                <v-layout wrap row d-flex>
                  <v-flex xs5 class="pa-1">
                    <div class="box" style="min-height: 150px">
                      <strong class="title">{{ $t('Sender') }}</strong>
                      <pre class="address" v-if="profile">{{ profile.pageaddress }}</pre>
                    </div>
                  </v-flex>
                  <v-flex xs7 class="pa-1" style="min-height: 300px">
                    <div class="box" style="min-height: 250px">
                      <strong class="title">{{ $t('Receiver') }}</strong>
                      <pre class="address">{{ order.nameaddress }}</pre>
                    </div>
                  </v-flex>
                </v-layout>

                <v-divider class="mt-3 mb-3"></v-divider>

                <v-layout d-flex>
                  <v-flex>
                    <div style="overflow:auto">
                      <img
                        class="current-bot-image"
                        :src="
                          'https://graph.facebook.com/' +
                            selectedBot.pageid +
                            '/picture?width=100&height=100&SameSite=None'
                        "
                        alt="Card image cap"
                        style="border:solid 1px #eee; border-radius: 50%;width:50px;height:50px;margin-right:5px;"
                      />
                      <h2 class="title" style="margin-top: 10px;">{{ selectedBot.pagename }}</h2>
                      <p class="address caption" v-if="profile">{{ profile.pageaddress }}</p>

                      <div class="hr" style="margin-bottom: 15px;"></div>
                      <h2 class="title">{{ order.first_name }} {{ order.last_name }}</h2>
                      <p class="caption">{{ order.nameaddress }}</p>
                    </div>
                  </v-flex>
                  <v-flex>
                    <h2 class="title">{{ $t('Receipt') }}</h2>
                    <v-layout d-flex class="caption">
                      <v-flex>{{ $t('Order Date') }}</v-flex>
                      <v-flex class="text-xs-right">{{
                        order.timestamp | DateFormat('DD/MM/YYYY')
                      }}</v-flex>
                    </v-layout>

                    <v-layout d-flex class="caption">
                      <v-flex>{{ $t('Shipping option') }}</v-flex>
                      <v-flex class="text-xs-right">
                        <img
                          v-if="order.shippingtype == 'normal'"
                          src="/static/img/assets/payment/thailandpost_logo.png"
                          alt
                          style="max-height: 50px; margin-right: 0; margin-left: auto"
                        />
                        <img
                          v-else-if="order.shippingtype == 'ems'"
                          src="/static/img/assets/payment/ems_logo.png"
                          alt
                          style="max-height: 50px; margin-right: 0; margin-left: auto"
                        />
                        <img
                          v-else-if="order.shippingtype == 'kerry'"
                          src="/static/img/assets/payment/kerry_logo.png"
                          alt
                          style="max-height: 50px; margin-right: 0; margin-left: auto"
                        />
                        <template v-else>
                          <template v-if="order.shippingtype">
                            <img
                              :src="
                                '/static/img/assets/payment/' + order.shippingtype + '_logo.png'
                              "
                              alt
                              style="max-height: 50px; margin-right: 0; margin-left: auto"
                            />
                            <div v-if="order.shippingtype == 'cod_charge'" class="caption">
                              {{ $t('cod_charge') }}
                            </div>
                          </template>
                        </template>
                      </v-flex>
                    </v-layout>
                    <template v-if="order.trackingno">
                      <v-layout d-flex class="caption">
                        <v-flex>{{ $t('Tracking') }}</v-flex>
                        <v-flex class="text-xs-right">{{ order.trackingno }}</v-flex>
                      </v-layout>
                    </template>

                    <v-layout d-flex class="caption">
                      <v-flex>{{ $t('Payment Method') }}</v-flex>
                      <v-flex class="text-xs-right">
                        <template
                          v-if="order.payment == 'banktransfer' || order.payment == 'transfer'"
                          >{{ $t('Bank Transfer') }}</template
                        >
                        <template v-else-if="order.payment == 'cod'">{{
                          $t('cod_charge')
                        }}</template>
                        <template v-else-if="order.payment == 'qrcode'">Qr Code</template>
                        <template v-else-if="order.payment == 'fbpay'">{{
                          $t('Mobile Banking')
                        }}</template>
                        <template v-else>{{ $t('Credit card') }}</template>
                      </v-flex>
                    </v-layout>

                    <v-divider class="mb-2 mt-2"></v-divider>

                    <strong>{{ $t('Product Detail') }}</strong>

                    <template v-if="typeof orderDetailFormat == 'string'">
                      <div class="pa-2">
                        <nl2br tag="p" :text="order.productdetail"></nl2br>
                      </div>
                    </template>
                    <template v-else-if="typeof orderDetailFormat == 'object'">
                      <div>
                        <template v-for="(order, oindex) in orderDetailFormat">
                          <v-layout d-flex class="caption" :key="'order_' + oindex">
                            <v-flex>
                              <div>
                                {{ order.name }} x {{ order.quantity }}
                                <template v-if="order.option">({{ order.option }})</template>
                              </div>
                            </v-flex>
                            <v-flex class="text-xs-right primary-color">฿{{ order.price }}</v-flex>
                          </v-layout>
                        </template>
                      </div>
                    </template>

                    <v-divider class="mt-2 mb-2"></v-divider>

                    <div>
                      <v-layout
                        d-flex
                        class="caption"
                        v-if="order.total != null && order.discount > 0"
                      >
                        <v-flex>{{ $t('Subtotal') }}:</v-flex>
                        <v-flex class="text-xs-right">
                          <span class="primary-color">฿{{ order.total | numberFormat }}</span>
                        </v-flex>
                      </v-layout>
                      <v-layout d-flex class="caption" v-if="order.shippingcharge != null">
                        <v-flex>{{ $t('Shipping fee') }}:</v-flex>
                        <v-flex class="text-xs-right">
                          <span class="primary-color"
                            >฿{{ order.shippingcharge | numberFormat }}</span
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout d-flex class="caption" v-if="order.discount > 0">
                        <v-flex>{{ $t('Discount') }}:</v-flex>
                        <v-flex class="text-xs-right">
                          <span class="primary-color">-฿{{ order.discount | numberFormat }}</span>
                        </v-flex>
                      </v-layout>
                      <v-layout d-flex class="caption" v-if="order.amount != null">
                        <v-flex>{{ $t('Total') }}:</v-flex>
                        <v-flex class="text-xs-right">
                          <span class="primary-color">฿{{ order.amount | numberFormat }}</span>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
              <div class="subpage"></div>
            </div>
          </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import Nl2br from 'vue-nl2br'
import config from '@/config'
import api from '@/api'

export default {
  props: ['value'],
  components: {
    Nl2br
  },
  data: function() {
    return {}
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      profile: 'getPageProfile',
      loadingProfile: 'getLoadingPageProfile'
    }),
    order: function() {
      return this.value
    },
    orderDetailFormat: function() {
      var text = ''
      try {
        text = JSON.parse(this.order.productdetail)
      } catch (error) {
        text = this.order.productdetail
      }
      return text
    }
  },
  mounted: function() {
    let vm = this
    document.addEventListener('keydown', this.escListener)
  },
  methods: {
    escListener(e) {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    },
    getShopProfile: function() {
      let vm = this
      if (!vm.selectedBot.pageid || vm.selectedBot.pageid == null) {
        return false
      }
      let data = {
        pageid: vm.selectedBot.pageid
      }
      let auth = null
      api.getShopProfile(data, function(error, response) {
        if (error) {
          console.error(error)

          return
        }
        // console.log(response)
        if (response.shopprofile) {
          vm.profile = response.shopprofile
        }
      })
    },
    printCover: function() {
      var printSection = $('#printSection')

      if (printSection.length == 0) {
        printSection = document.createElement('div')
        printSection.id = 'printSection'
        $('body').append(printSection)
      } else {
        printSection.empty()
      }
      $(`#printable_${this.order.id}`)
        .clone(true)
        .appendTo('#printSection')
      window.print()
    }
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.escListener)
  }
}
</script>

<style scoped>
.print-table div.row > div {
  display: inline-block;
  border: solid 1px #ccc;
}
.print-table div.row {
  display: block;
  white-space: nowrap;
}
.print-table {
  display: block;
}
pre {
  white-space: pre-wrap; /* css-3 */
  white-space: -moz-pre-wrap; /* Mozilla, since 1999 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word; /* Internet Explorer 5.5+ */
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/PrintCover.vue